import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { AuthorizationSelectors } from '@next/core-lib/authorization';
import { Cart, OrderTypes } from '@next/core-lib/cart';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/models/app.models';

@Component({
  selector: 'app-price-notification',
  templateUrl: './price-notification.component.html',
  imports: [NgIf, MatIcon, AgrI18nSharedModule],
})
export class PriceNotificationComponent {
  @Input() cart: Cart;
  hasAtLeastAdvisorRole$ = this.store.select(AuthorizationSelectors.hasAtLeastAdvisorRole);

  constructor(private readonly store: Store<AppState>) {}

  computePriceForCart(): number {
    if (!this.cart?.lines) {
      return 0;
    }

    return this.cart.lines.reduce((totalPrice, line) => {
      const netPrice = parseFloat(line?.priceResults?.[0]?.netPrice);
      return isNaN(netPrice) ? totalPrice : totalPrice + netPrice;
    }, 0);
  }

  shouldShowNotification(): boolean {
    return this.isSalesOrder() && this.isPriceBelowThreshold();
  }

  isSalesOrder(): boolean {
    if (this.cart === null) {
      return false;
    }

    return this.cart.type === OrderTypes.salesOrder;
  }

  isPriceBelowThreshold(): boolean {
    const cartPrice = this.computePriceForCart();
    return cartPrice !== 0 && cartPrice < 330;
  }
}
